module.exports = __webpack_public_path__ + "img/blog3.f0f60cb4.jpg";